(function($, undefined) {
	'use strict';
	var account;
	var form;
	var submitBtn;
	var fileInput;
	
	var previewFile = function(e) {
		var t = $(this);
		var currForm = t.closest('.demo-form');
		var isVideo = t.closest('.demo-form').hasClass('video');
		var $ctn = t.closest('.form-input-big-ctn');
		var allowedExt = isVideo ? ['mp4','webm', 'mov'] : ['mp3','m4a','wav'];
		var allowedSize = isVideo ? 104857600 : 10485760; // 100mb video / 10mb audio
		var media;
		var file = currForm.find(fileInput)[0].files[0];
		var size;
		var re = /(?:\.([^.]+))?$/;
		var ext;

		if (file) {
			size = file.size;
			ext = re.exec(file.name)[1];

			if (size <= allowedSize) {
				if (allowedExt.indexOf(ext.toLowerCase()) !== -1) {
					if (isVideo) {
						media = document.createElement('VIDEO');
					} else {
						media = new Audio();
					}

					media.src = window.URL.createObjectURL(e.target.files[0]);
					media.controls = 'controls';
					
					$ctn.children('audio, video').remove();
					$ctn.append(media);
				} else {
					currForm.find(fileInput).val('');
					if (isVideo) {
						form.showErrorPopupAnimation('audition-form-artist-file-ext-video-error');
					} else {
						form.showErrorPopupAnimation('audition-form-artist-file-ext-error');
					}
				}
			} else {
				currForm.find(fileInput).val('');
				if (isVideo) {
					form.showErrorPopupAnimation('demo-form-file-video-size-message-error');
				} else {
					form.showErrorPopupAnimation('demo-form-file-size-message-error');
				}
			}
		}
	};

	var getNewPersonTags = function(personTags, demoTags) {
		var joinedTags = personTags.concat(demoTags.split(','));
		var arr = [];

		$.each(joinedTags, function(i, el){
			if($.inArray(el, arr) === -1) {arr.push(el);}
		});

		return arr;
	};

	var submitForm = function () {
		var t = $(this);
		var currForm = t.closest('.demo-form');
		var popup = t.closest('.popup');
		
		form.validateForm(currForm);
		
		if (!currForm.hasClass('has-error')) {
			popup.addClass('is-processing');
			t.addClass('disabled');

			var personIntLang = currForm.attr('data-person-int-lang').split(',');
			var personType = currForm.attr('data-person-type').split(',');
			var personTimbre = currForm.attr('data-person-timbre').split(',');
			var personIntType = currForm.attr('data-person-int-type').split(',');
			var personVoiceAge = currForm.attr('data-voice-age').split(',');
			var personTypeVideo = currForm.attr('data-person-type-video').split(',');
			var personFormatVideo = currForm.attr('data-person-format-video').split(',');
			var personIntTypeVideo = currForm.attr('data-person-int-type-video').split(',');
			
			var newIntLang = account.formatStringArray('.account-demo-int-lang-list', currForm);
			var newType = account.formatStringArray('.account-demo-type-list', currForm);
			var newTimbre = account.formatStringArray('.account-demo-timbre-list', currForm);
			var newIntType = account.formatStringArray('.account-demo-interpretation-type-list', currForm);
			var newVoiceAge = account.formatStringArray('.account-demo-voice-age-list', currForm);
			var newTypeVideo = account.formatStringArray('.account-demo-type-video-list', currForm);
			var newFormatVideo = account.formatStringArray('.account-demo-format-video-list', currForm);
			var newIntTypeVideo = account.formatStringArray('.account-demo-interpretation-type-video-list', currForm);
			
			//Here is to add the new specs to the profile
			var newPersonIntLang = getNewPersonTags(personIntLang, newIntLang);
			var newPersonType = getNewPersonTags(personType, newType);
			var newPersonTimbre = getNewPersonTags(personTimbre, newTimbre);
			var newPersonIntType = getNewPersonTags(personIntType, newIntType);
			var newPersonVoiceAge = getNewPersonTags(personVoiceAge, newVoiceAge);
			var newPersonTypeVideo = getNewPersonTags(personTypeVideo, newTypeVideo);
			var newPersonFormatVideo = getNewPersonTags(personFormatVideo, newFormatVideo);
			var newPersonIntTypeVideo = getNewPersonTags(personIntTypeVideo, newIntTypeVideo);
			
			$('.form-input:not([name="demo-year"]):not([name="demo-text"])', currForm).addClass('required').closest('.form-input-big-ctn').addClass('required');
			
			var data = {
				field1: 'demo',
				field2: $('.form-input[name="demo-title"]', currForm).val(),
				field4: newVoiceAge,
				field5: newIntLang,
				field6: newType,
				field7: newTimbre,
				field8: $('.form-input[name="demo-text"]', currForm).val(),
				field9: currForm.attr('data-person-id'),
				field14: newIntType,
				field16: $('input[name="fictive"]', currForm).prop('checked'),
				field17: $('select[name="demo-year"]', currForm).val(),
				field19: $('input[name="field19"]', currForm).val(),
				field20: newTypeVideo,
				field21: newFormatVideo,
				field22: newIntTypeVideo,
				dateField1Year: new Date().getFullYear(),
				dateField1Month: new Date().getMonth(),
				dateField1Day: new Date().getDate(),
				dateField1Hour: new Date().getHours(),
				dateField1Minute: new Date().getMinutes(),
				dateField1Second: new Date().getSeconds(),
				friendlyUrlField: 'field2',
				ajax: true
			};
			
			if ($('input[name="demo-file-id"]', currForm).val().length !== 0) {
				data.field3 = $('input[name="demo-file-id"]', currForm).val();
			}
			
			if ($('input[name="demo-file-size"]', currForm).val().length !== 0) {
				data.field12 = $('input[name="demo-file-size"]', currForm).val();
			}
			
			if (currForm.attr('data-id') !== undefined && currForm.attr('data-id') !== '') {
				data.id = currForm.attr('data-id');
			}

			var file = currForm.find(fileInput)[0].files[0];
			var size;
			var re = /(?:\.([^.]+))?$/;
			var ext;

			var _update = function() {
				var ajaxCount = 2;

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					method: 'POST',
					data: data,
					success: function (response) {
						ajaxCount--;
						if (ajaxCount <= 0) {
							window.location.reload();
						}
					}
				}); 

				$.ajax({
					url: '/action/updatePerson',
					cache: false,
					data: {
						field4: newPersonType.toString(),
						field18: newPersonIntLang.toString(),
						field19: newPersonVoiceAge.toString(),
						field20: newPersonIntType.toString(),
						field29: newPersonTimbre.toString(),
						field32: newPersonTypeVideo.toString(),
						field33: newPersonFormatVideo.toString(),
						field34: newPersonIntTypeVideo.toString(),
						ajax: true
					},
					success: function (response) {
						ajaxCount--;
						if (ajaxCount <= 0) {
							window.location.reload();
						}
					}
				});
			};

			if (file) {
				size = file.size;
				ext = re.exec(file.name)[1];

				var fd = new FormData();
				fd.append('image', file);
				fd.append('customLabel', 'file');
				fd.append('directory', 'Demos');
				fd.append('ajax', 'true');

				$.ajax({
					url: '/action/uploadCroppedImage',
					cache: false,
					contentType: false,
					processData: false,
					method: 'POST',
					data: fd,
					success: function (response) {
						var newId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
						$('input[name="demo-file-id"]', currForm).val(newId);
						$('input[name="demo-file-size"]', currForm).val(size);
						data.field3 = newId;
						data.field12 = size;
						data.field18 = ext;

						_update();
					},
					error: function (xhr, textStatus) {
						console.error(textStatus);

						t.removeClass('disabled');
						popup.removeClass('is-processing');
					}
				});
				
				$('.form-item-upload-input', currForm).removeClass('error').closest('.form-input-big-ctn').removeClass('error');
			} else {
				_update();
			}
		}
	};

	var init = function() {
		account = Fw.page.models().account;
		form = Fw.component.models().form;
		submitBtn = $('.demo-form-btn');
		fileInput = $('input[name="demo-file"]');
		
		submitBtn.click(submitForm);
		fileInput.change(previewFile);
	};
	
	$(init);

})(jQuery);

